




























































import Vue from 'vue';
import { mask } from 'vue-the-mask';
import debounce from 'lodash/debounce';
import { isObject, isString } from '@/utilities/helpers';

export default Vue.extend({
	name: 'NpInput',
	inject: ['$validator'],
	directives: { mask },
	inheritAttrs: false,
	props: {
		containerClass: {
			default: '',
		},
		debounce: {
			type: [Number],
			default: 0,
		},
		description: {
			type: String,
			default: '',
		},
		displayName: {
			type: [Boolean, String],
			default: '',
		},
		hasLabel: {
			type: Boolean,
			default: true,
		},
		inputClass: {
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		mask: {
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		validation: {
			type: [Object, String],
		},
		value: {},
	},

	created() {
		if (this.debounce > 0) {
			this.changed = debounce((value: any) => {
				this.$emit('change', value);
			}, this.debounce);
		}
	},

	computed: {
		inputId(): string {
			return this.$attrs.id || this.name;
		},
		inputMask(): any {
			if (this.mask) {
				return this.mask;
			}

			if (this.$attrs.type === 'tel') {
				return ['(###) ###-####', '(###) ###-#### ext. ######'];
			}

			return false;
		},
		labelName(): string {
			return this.label || this.ucwords(this.prettyName);
		},
		listeners(): any {
			return {
				...this.$listeners,
				input: (event: any) => {
					const value = event.target.value as any;
					this.$emit('input', value);
					this.changed(value);
				},
			};
		},
		prettyName(): string {
			const pretty = this.displayName ? this.displayName.toString() : this.name.replace(/_/g, ' ');
			return pretty;
		},
		required(): boolean {
			return this.$attrs.required
				|| (isObject(this.validation) && (this.validation as any).required)
				|| (isString(this.validation) && this.validation.indexOf('required') >= 0);
		},
	},

	methods: {
		ucwords(value: string): string {
			return value.replace(
				/^([a-z])|\s+([a-z])/g,
				($1: string) => $1.toUpperCase(),
			);
		},
		updateValue(value: any) {
			this.$emit('input', value);
			(this as any).errors.remove(this.name);
		},
		changed(value: any) {
			this.$emit('change', value);
		},
	},
});
